import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";

const NotFound: React.FC = () => {
  return (
    <div className="not-found">
      <div className="container">
        <div className="not-found-content">
          <h1>404</h1>
          <div className="not-found-actions">
            <Link to="/" className="btn btn-secondary">
              back home . . .
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
